"use client";

import { Checkbox } from "@/components/ui/checkbox";
import { prettyFormatDate } from "@/lib/utils";
import type { ColumnDef } from "@tanstack/react-table";
import type { Audience } from "@zora/api/concerns/audiences/audience.router";
import { DataTableColumnHeader } from "./residents.header";

export const columns: ColumnDef<Audience>[] = [
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && "indeterminate")
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
        className="translate-y-[2px]"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
        className="translate-y-[2px]"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "fullName",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => <div>{row.getValue("fullName")}</div>,
    enableSorting: true,
    enableHiding: true,
    filterFn: (row, _id, value) => {
      return (
        row.original?.fullName?.toLowerCase().includes(value.toLowerCase()) ||
        false
      );
    },
  },
  {
    accessorKey: "email",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Email" />
    ),
    cell: ({ row }) => {
      const email = row.original.email;

      return (
        <div className="flex space-x-2">
          <span className="max-w-[500px] truncate font-medium">{email}</span>
        </div>
      );
    },
  },
  {
    accessorKey: "phoneNumber",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Phone" />
    ),
    cell: ({ row }) => {
      const phoneNumber = row.original.phoneNumber;

      return (
        <div className="flex space-x-2">
          <span className="max-w-[500px] truncate font-medium">
            {phoneNumber}
          </span>
        </div>
      );
    },
  },
  {
    accessorKey: "createdAt",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Sign Up Date" />
    ),
    cell: ({ row }) => {
      const createdAt = row.original.createdAt;

      const formattedDate = prettyFormatDate(createdAt);

      return (
        <div className="flex items-center">
          <span>{formattedDate}</span>
        </div>
      );
    },
  },
  // {
  //   id: "actions",
  //   cell: ({ row }) => <DataTableRowActions row={row} />,
  // },
];
